jQuery(function($) {
  const mapTarget = $('#googlemap') // Google Mapエリア
  let getLatLng = false // 位置情報を取り終えたかのフラグ
  // 現在地
  let userLat = 0
  let userLng = 0

  // Geolocation APIの対応確認
  if (navigator.geolocation) {
    // Geolocation APIに対応している
    getPosition()
  } else {
    // Geolocation APIに対応していない
    mapTarget.text('ご使用の閲覧環境が位置情報機能に対応していません。対応環境で再度お試しください。')
  }

  // 現在地取得処理
  function getPosition() {
    // 現在地を取得
    navigator.geolocation.getCurrentPosition(
      // 取得成功した場合
      function(position) {
        // ユーザーの座標
        userLat = position.coords.latitude
        userLng = position.coords.longitude
        // mapTarget.text('緯度:' + userLat + ',経度' + userLng)

        positionStandby()
      },
      // 取得失敗した場合
      function(error) {
        switch (error.code) {
          case 1: //PERMISSION_DENIED
            // 位置情報の利用が許可されていない
            mapTarget.text('位置情報の利用が許可されていません。位置情報機能を許可いただいた上で再度お試しください。')
            break
          case 2: //POSITION_UNAVAILABLE
            // 現在位置が取得できない
            mapTarget.text('現在位置が取得できませんでした。端末やブラウザの設定をご確認の上再度お試しください。')
            break
          case 3: //TIMEOUT
            // タイムアウトになった
            mapTarget.text('エラーが発生しました。時間を開けて再度お試しください。')
            break
          default:
            // その他のエラー
            mapTarget.text('エラーが発生しました。時間を開けて再度お試しください。　エラーコード:' + error.code)
            break
        }
      }
    )
  }

  // 座標が取得し終えたら次の処理に移る
  function positionStandby() {
    if (!getLatLng) {
      if (userLat !== 0 && userLng !== 0) {
        getLatLng = true
        drawMap('googlemap') //住所を指定して描画実行
        ajaxContents('#result') // 周辺店舗検索結果を描画
        ajaxContents('#result-detail') // 周辺店舗検索結果を描画
        // console.log(hUrl + 'near-shop/?lat=' + userLat + '&lng=' + userLng)
      } else {
        setTimeout(positionStandby, 500) // 次回の処理を登録
      }
    }
  }
  /*
       ##     ##    ###    ########
       #### ####  ##   ##  ##     ##
       ## ### ## ##     ## ########
       ##     ## ######### ##
       ##     ## ##     ## ##
*/
  /* global google markerData */
  // console.log(markerData)
  function drawMap(id) {
    let googlemap
    //GoogleMap 住所　ID
    // console.log(userLat, userLng)
    var mapObj = document.getElementById(id) //指定IDにマップ描画
    var mapLatlng = new google.maps.LatLng(userLat, userLng)
    var mapOptions = {
      //マップの表示オプション
      mapTypeId: google.maps.MapTypeId.ROADMAP, //マップタイプ
      center: mapLatlng, //中心座標
      zoom: 10, //ズームレベル
      mapTypeControl: false, //マップタイプを変更可能にするか
      scaleControl: true, //ズームレベルを変更可能にするか
      scrollwheel: false //マウスホイール操作に対応するか
    }
    googlemap = new google.maps.Map(mapObj, mapOptions) //マップを表示する
    var marker = new google.maps.Marker({
      //マーカーを表示する
      map: googlemap, //設置するマップ
      position: mapLatlng, //マーカーを表示させる座標
      animation: google.maps.Animation.DROP //ドロップアニメーションでマーカーを描画
      // icon:".png"              //マーカー画像
    })

    for (var i = 0; i < markerData.length; i++) {
      ;(function(lat, lng, url) {
        if (lat !== '') {
          marker[i] = new google.maps.Marker({
            // マーカーの追加
            map: googlemap, // マーカーを立てる地図を指定
            position: new google.maps.LatLng(lat, lng), // マーカーを立てる位置を指定
            animation: google.maps.Animation.DROP //ドロップアニメーションでマーカーを描画
          })
          //クリックしたら指定したurlに遷移するイベント
          marker[i].addListener('click', function() {
            window.open(url, '_blank')
          })
        }
      })(markerData[i]['lat'], markerData[i]['lng'], markerData[i]['url'])
    }

    new google.maps.InfoWindow({
      //吹き出しを表示する
      content: '現在地' //出力内容
    }).open(googlemap, marker) //対象のマップとマーカーを指定
  }

  /*
          ###          ##    ###    ##     ##
         ## ##         ##   ## ##    ##   ##
       ##     ##       ## ##     ##    ###
       ######### ##    ## #########   ## ##
       ##     ##  ######  ##     ## ##     ##
*/
  /* global hUrl */
  function ajaxContents(target) {
    $(target).html('<div class="md-loading active"></div>')
    $.ajax({
      url: hUrl + 'near-shop/?lat=' + userLat + '&lng=' + userLng,
      dataType: 'html',
      success: function(data) {
        const outHtml = $($.parseHTML(data)) //parse

        $(target)
          .html(outHtml.find(target)[0].innerHTML)
          .animate({ scrollTop: 0 }, '1')

        shopDistance()
      },
      error: function(data) {}
    })
  }

  /*
       ########  ####  ######  ########
       ##     ##  ##  ##    ##    ##
       ##     ##  ##  ##          ##
       ##     ##  ##   ######     ##
       ##     ##  ##        ##    ##
       ##     ##  ##  ##    ##    ##
       ########  ####  ######     ##
*/
  // 距離計算
  function shopDistance() {
    $('.js-distance').each(function() {
      const lat = $(this).data('lat')
      const lng = $(this).data('lng')
      const km = distance(userLat, userLng, lat, lng)

      $(this).attr('data-distance', km.toFixed(2))
      $(this)
        .find('.js-distance--html')
        .html('現在地から約<span class="red">' + km.toFixed(2) + '</span>km')
    })
    domSort()
  }
  function distance(lat1, lng1, lat2, lng2) {
    lat1 *= Math.PI / 180
    lng1 *= Math.PI / 180
    lat2 *= Math.PI / 180
    lng2 *= Math.PI / 180
    return 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
  }

  /*
        ######   #######  ########  ########
       ##    ## ##     ## ##     ##    ##
       ##       ##     ## ##     ##    ##
        ######  ##     ## ########     ##
             ## ##     ## ##   ##      ##
       ##    ## ##     ## ##    ##     ##
        ######   #######  ##     ##    ##
*/
  function domSort() {
    const sortVal = 'distance'
    const sortBase = '.js-sort'
    const sortItem = '.js-sort-item'
    $(sortBase).each(function() {
      let sortItems = []
      $(this)
        .find(sortItem)
        .each(function() {
          sortItems.push($(this)[0].outerHTML)
        })

      sortItems.sort(function(a, b) {
        //★カスタムデータ属性の値を参照
        var aa = $(a).data(sortVal)
        var bb = $(b).data(sortVal)
        //昇順ソート。不等号を逆にすることで降順にできる。
        if (aa > bb) {
          return 1
        } else if (aa < bb) {
          return -1
        }
        return 0
      })
      $(this).empty()
      for (let i = 0; i < sortItems.length; i++) {
        $(this).append(sortItems[i])
      }
    })
  }
})
